import React, { useState } from "react";

export const CartCountContext = React.createContext();

function CartCountProvider({ children }) {
  const [triggerCount, setTriggerCount] = useState(true);
  const [cartCount, setCartCount] = useState(true);
  const [stats, setStats] = useState({});
  const [scrollTick, setScrollTick] = useState(0);
  const [scrollContactTick, setContactScrollTick] = useState(0);
  const [scrollHomeTick, setHomeScrollTick] = useState(0);

  const value = React.useMemo(() => {
    return {
      triggerCount,
      setTriggerCount,
      cartCount,
      setCartCount,
      stats,
      setStats,
      scrollTick,
      setScrollTick,
      scrollContactTick,
      setContactScrollTick,
      scrollHomeTick,
      setHomeScrollTick,
    };
  }, [
    triggerCount,
    setTriggerCount,
    cartCount,
    setCartCount,
    stats,
    setStats,
    scrollTick,
    setScrollTick,
    scrollContactTick,
    setContactScrollTick,
    scrollHomeTick,
    setHomeScrollTick,
  ]);

  return (
    <CartCountContext.Provider value={value}>
      {children}
    </CartCountContext.Provider>
  );
}

export default CartCountProvider;
